import { CUSTOMER_APP_URL } from '@m/config/env';

export function getCustomerAppUrl() {
  return CUSTOMER_APP_URL;
}
